module.exports = __webpack_public_path__ + "img/_ABS9852(1).4a1a3ed7.jpg";